import type { HydraGetSubscriptionItem } from '@/lib/services/Hydra/account/GET/getSubscriptions'

type Props = {
  line: HydraGetSubscriptionItem['lines']['items'][number]
}

export const SubscriptionAccordionLineItem = ({ line }: Props) => {
  if (!line.productData) return null

  const variationFlavor = line.productData.variations.find(
    (variation) => variation.sku === line.item.id.unicity,
  )?.combinationName

  return (
    <div className="space-x-1" key={line.item.id.unicity}>
      <span className="font-bold">({line.quantity})</span>
      <span className="font-bold">{line.productData.name}</span>
      <>
        <span>-</span>
        <span>{variationFlavor}</span>
      </>
    </div>
  )
}
